import { APICore } from "./apiCore";

const api = new APICore();

// function ApiGetAllTimeline(params) {
//   const baseUrl = "/api/admin/transaksireflexy/event";
//   return api.get(`${baseUrl}`, params);
// }

function ApiGetAllTimeline(params) {
  const baseUrl = "/api/admin/transaksireflexy/event";
  return api.get(`${baseUrl}`, params);
}
function ApiPostTimeLine(params) {
  const baseUrl = "/api/admin/transaksireflexy/event";
  return api.post(`${baseUrl}`, params);
}

export { ApiGetAllTimeline, ApiPostTimeLine };
